import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SiTabComponent, SiTabsetComponent } from '@siemens/element-ng/tabs';
import { SiIconComponent } from '@siemens/element-ng/icon';
import { SiTooltipDirective } from '@siemens/element-ng/tooltip';
import { CommonModule } from '@angular/common';
import { TabModel } from '../../../interfaces/tab-model-interface';

export interface TabAction {
  iconClass: string;
  tooltip: string;
  click: () => void;
  disabled?: boolean;
}

@Component({
  selector: 'app-tabset',
  imports: [CommonModule, SiTabComponent, SiTabsetComponent, SiIconComponent, SiTooltipDirective],
  templateUrl: './tabset.component.html',
  styleUrl: './tabset.component.scss',
})

export class TabsetComponent {
  @Input() tabs: TabModel[] = [
    {
      heading: 'Editor',
      closable: false,
      active: true
    }
  ];
  
  @Input() selectedTabIndex = 0;
  @Input() actions: TabAction[] = [];
  /** Whether the associated collapsible panel is currently collapsed. */
  @Input() isCollapsed?: boolean;
  /** Callback to toggle the associated collapsible panel. Renders a collapse/expand button when provided. */
  @Input() onToggleCollapse?: () => void;
  /**
   * Orientation of the collapse: 'vertical' (panel collapses up/down) or 'horizontal' (panel collapses left/right).
   * Controls the direction the collapse icon points. Defaults to 'vertical'.
   */
  @Input() collapseOrientation: 'vertical' | 'horizontal' = 'vertical';

  @Output() tabChanged = new EventEmitter<number>();
  @Output() tabClosed = new EventEmitter<TabModel>();

  onTabActiveChange(index: number, isActive: boolean): void {
    if (isActive) {
      this.tabChanged.emit(index);
    }
  }

  closeTab(tab: TabModel): void {
    const index = this.tabs.findIndex(t => t.heading === tab.heading);
    this.tabs.splice(index, 1);
    this.tabClosed.emit(tab);
    
    // Adjust selected index if needed
    if (this.selectedTabIndex >= this.tabs.length && this.tabs.length > 0) {
      this.selectedTabIndex = this.tabs.length - 1;
    }
  }
}
